import { ITradingState } from '../../types';

export const initState: ITradingState = {
  selectedTrade: null,
  tradeExecutionInProgress: false,
  tradeCreationInProgress: false,
  tradeCreationError: false,
  tradeExecutionError: false,
};
